import { useState } from 'react'
import ScrollMenu from 'react-horizontal-scrolling-menu'

export default function Slide({ section, sections, setSection }) {
  //! slide section
  const [selectedMenuLabel, setSelectedMenuLabel] = useState(section)
  const menuLabels = ["All"].concat(sections.map(l => l.sectionName))

  const Arrow = ({ text, className }) => <div className={className}>{text}</div>
  const MenuItem = ({ text, selected }) => <div className={`menu-item ${selected ? 'active' : ''}`}>{text}</div>
  const Menu = (list, selectedItem) => list.map(label => <MenuItem text={label} key={label} selected={selectedItem === label} />)

  return (
    <ScrollMenu
      data={Menu(menuLabels, selectedMenuLabel)}
      arrowLeft={Arrow({ text: '<', className: 'arrow-prev' })}
      arrowRight={Arrow({ text: '>', className: 'arrow-next' })}
      selected={selectedMenuLabel}
      onSelect={(key: string) => {
        setSelectedMenuLabel(key)
        setSection(key)
      }}
      alignCenter={false}
    />
  )
}
